module.exports = __webpack_public_path__ + "static/media/market.d6b66c47.jpg";